/**
 * Domain model for `/businesses/analytics/operations`.
 *
 * Reads BOTH camelCase (current BE wire format) and snake_case (future-
 * proof in case ClassSerializerInterceptor is enabled).
 */

const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined) return obj[k];
  }
  return undefined;
};

export class AnalyticsOperations {
  constructor(data = {}) {
    const trend = pick(data, "responseTimeTrend", "response_time_trend") || [];
    this.responseTimeTrend = trend.map(p => ({
      date: p.date,
      avgSeconds: pick(p, "avgSeconds", "avg_seconds") ?? 0,
      sampleSize: pick(p, "sampleSize", "sample_size") ?? 0
    }));

    const dur =
      pick(data, "durationByServiceType", "duration_by_service_type") || [];
    this.durationByServiceType = dur.map(p => ({
      serviceTypeId: pick(p, "serviceTypeId", "service_type_id"),
      avgSeconds: pick(p, "avgSeconds", "avg_seconds") ?? 0,
      sampleSize: pick(p, "sampleSize", "sample_size") ?? 0
    }));

    const declines = pick(data, "declineReasons", "decline_reasons") || [];
    this.declineReasons = declines.map(r => ({
      reason: r.reason,
      count: r.count ?? 0
    }));
  }
}
